import {Button, Flex} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleRight, faCode, faFileLines, faSquare} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import {DraftComponent, DraftElement} from "../../../../../../../../feature/Draft";


export const ComponentItem = (
    props: {
        component: DraftComponent,
        active?: boolean,
        fullFilled?: boolean,
        onComponentSelected?: (component: DraftComponent) => void,
        embedded?: boolean,
        showEmbeddingState?: boolean,
        children?: React.ReactNode,
        onExpand?: (component: DraftComponent) => void,
        expanded?: boolean,
    }
) => {

    return (
        <Flex
            vertical={true}
            gap={10}
            key={`component-${props.component.id}`}>
            <Button
                key={props.component.id}
                style={{
                    textAlign: 'start',
                    height: "auto",
                    background: props.active ? "#f0f0f0" : undefined,
                    padding: '8px 8px 8px 16px'
                }}
                type={'text'}
                onClick={() => {
                    props.onComponentSelected?.(props.component)
                }}>
                <Flex
                    style={{width: "100%"}}
                    justify={'space-between'}
                    gap={10}
                    align={'center'}
                >

                    <FontAwesomeIcon
                        style={{color: props.fullFilled == true ? "#0958d9" : props.fullFilled == false ? "#cccccc" : "#faad14"}}
                        icon={faFileLines}/>

                    <div style={{
                        flexGrow: 1,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    }}>{props.component.title}</div>
                    <Flex gap={10} align={'center'}>
                    <span className="fa-layers fa-fw fa-lg" style={{display: props.showEmbeddingState ? 'block' : 'none'}}>
                        <FontAwesomeIcon
                            icon={faSquare}
                            color={props.embedded == true ? "#17813b" : props.embedded == false ? "#ccc" : "#faad14"}/>
                        <FontAwesomeIcon
                            icon={faCode}
                            className={"fa-inverse"}
                            transform="shrink-8"/>
                    </span>
                        <FontAwesomeIcon
                            style={{
                                background: "#ffffff",
                                border: "1px solid #eee",
                                borderRadius: 20,
                                padding: 5,
                                aspectRatio: 1
                            }}
                            icon={props.expanded ? faAngleDown : faAngleRight}
                            onClick={(e) => {
                                props.onExpand?.(props.component)
                                e.stopPropagation()
                            }}/>
                    </Flex>
                </Flex>
            </Button>
            <Flex
                style={{marginLeft: 20}}
                vertical={true}
                gap={10}>
                {props.expanded
                    ? props.component.elements?.length > 0
                        ? props.children
                        : <Button style={{textAlign: 'start'}} disabled={true} type={'text'}>
                            No elements added yet
                        </Button>
                    : ''
                }
            </Flex>
        </Flex>
    )
}